import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { AuthProvider } from "@/lib/auth";
import { Toaster } from "sonner";

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, refetchOnWindowFocus: false } },
});

const savedTheme = localStorage.getItem("trak-theme") || "dark";
document.documentElement.classList.toggle("dark", savedTheme === "dark");

// Safety net: 401s from in-flight requests during logout/auth teardown are benign.
// The axios interceptor handles real session expiry; here we just stop these from
// surfacing as uncaught runtime errors (dev overlay / console noise).
window.addEventListener("unhandledrejection", (e) => {
  const r = e.reason;
  if (r && (r.name === "AxiosError" || r.isAxiosError) && r.response?.status === 401) {
    e.preventDefault();
  }
});
// Benign Chromium layout warning (Radix Select/Dialog resizing); not an app error.
window.addEventListener("error", (e) => {
  if (typeof e.message === "string" && e.message.startsWith("ResizeObserver loop")) {
    e.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <App />
        <Toaster theme="dark" position="bottom-right" />
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
